import React from 'react';
import UploadFileComponent from "../components/uploadFileComponent";

export default function DocumentPreFillView() {

  return (
    <UploadFileComponent />
  );
}